// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"222":"82edea4b","264":"f11ff7b9","290":"ef28b177","358":"bcb0cbbc","420":"ed589dd7","571":"17b32d5f","672":"02b89577"}[chunkId] + ".chunk.js";
};